(function () {
  var SCROLLED_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0721/9953/6805/files/AIVARI_Logo_1.png';
  var SCROLL_THRESHOLD = 10;

  function initScrollEffects() {
    var logoImg = document.querySelector('.header__heading-logo img');
    if (!logoImg) {
      logoImg = document.querySelector('.header__heading a img, header img[class*="logo"]');
    }
    var headerWrapper = document.querySelector('.header-wrapper');
    var defaultLogoURL = logoImg ? logoImg.src : null;

    if (logoImg) {
      logoImg.style.transition = 'opacity 300ms ease';
    }

    function applyEffects(isScrolled) {
      if (logoImg && defaultLogoURL) {
        var nextSrc = isScrolled ? SCROLLED_LOGO_URL : defaultLogoURL;
        if (logoImg.src !== nextSrc) {
          logoImg.style.opacity = '0';
          setTimeout(function () {
            logoImg.src = nextSrc;
            if (isScrolled) {
              logoImg.removeAttribute('srcset');
            }
            logoImg.style.opacity = '1';
          }, 300);
        }
      }
      if (headerWrapper) {
        if (isScrolled) {
          headerWrapper.classList.add('header--scrolled');
        } else {
          headerWrapper.classList.remove('header--scrolled');
        }
      }
    }

    function onScroll() {
      applyEffects(window.scrollY > SCROLL_THRESHOLD);
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollEffects);
  } else {
    initScrollEffects();
  }
})();